import { render, staticRenderFns } from "./ProportionAgentContribution.vue?vue&type=template&id=2d701036&scoped=true&"
import script from "./ProportionAgentContribution.vue?vue&type=script&lang=js&"
export * from "./ProportionAgentContribution.vue?vue&type=script&lang=js&"
import style0 from "./ProportionAgentContribution.vue?vue&type=style&index=0&id=2d701036&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d701036",
  null
  
)

export default component.exports